import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';
import Utils from './Utils';
import { FormControlLabel, Radio } from '@material-ui/core';

const styles = theme => ({
  root: {
    display: 'flex',
  },
  formControl: {
    margin: theme.spacing.unit * 3,
  },
  group: {
    margin: `${theme.spacing.unit}px 0`,
  },
});
function Transition (props) {
  return <Slide direction='down' {...props} />;
}

class AlertDialogSlide extends React.Component {
  utils = new Utils();
  state = {
    error: false,
    valorCampoDialog: '',
    valueRadio: 'CNPJ',
  }
  handleClickConfirmar = () => {
    if (this.state.valorCampoDialog === '') {
      this.setState({ error: true });
    } else {
      this.props.handleClick(this.state.valorCampoDialog.replace(/([-.*+?^=!:${}()|[\]/\\])/g, ''));
    }
  }
  handleFocus = event => {
    this.setState({error: false});
  }
  handleChangeText = event => {
    var novoValor = event.target.value;
    if (this.props.isCPFCNPJ) {
      if (this.state.valueRadio === 'CNPJ') {
        novoValor = this.utils.formatCNPJTextField(novoValor, event.target.defaultValue);
      } else {
        novoValor = this.utils.formatCPFTextField(novoValor, event.target.defaultValue);
      }
    }
    this.setState({ [event.target.name]: novoValor });
  };
  handleClose = () => {
    this.setState({valorCampoDialog: '', valueRadio: 'CNPJ'});
    this.props.handleClose();
  };
  handleChangeRadio = event => {
    this.setState({ valueRadio: event.target.value, valorCampoDialog: '' });
  };
  render () {
    const { open, handleClose, handleClick, title, message, classes } = this.props;

    return (
      <div>
        <Dialog
          open={open}
          TransitionComponent={Transition}
          keepMounted
          onClose={handleClose}
          aria-labelledby='alert-dialog-slide-title'
          aria-describedby='alert-dialog-slide-description'
        >
          <DialogTitle id='alert-dialog-slide-title'>
            {title}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id='alert-dialog-slide-description'>
              {message}
            </DialogContentText>
            { this.props.isCPFCNPJ &&
              <div className={classes.root}>
                <FormControlLabel
                  label='CNPJ'
                  control={<Radio
                    checked={this.state.valueRadio === 'CNPJ'}
                    aria-label='CNPJ'
                    onChange={this.handleChangeRadio}
                    value='CNPJ'
                    name='radio-CNPJ' />}
                />
                <FormControlLabel
                  label='CPF'
                  control={<Radio
                    checked={this.state.valueRadio === 'CPF'}
                    aria-label='CPF'
                    onChange={this.handleChangeRadio}
                    value='CPF'
                    name='radio-CPF' />}
                />
              </div>}
            { this.props.editavel &&
            <TextField
              autoFocus
              error={this.state.error}
              margin='dense'
              name='valorCampoDialog'
              label={this.state.error && 'Favor preencher este campo'}
              fullWidth
              multiline
              style={{maxlength: '500'}}
              value={this.state.valorCampoDialog}
              rowsMax='10'
              onFocus={this.handleFocus}
              onChange={this.handleChangeText}
              // helperText='(max. 500 caracteres)'
            />}
          </DialogContent>
          <DialogActions>
            { !this.props.editavel
              ? <Button onClick={this.handleClose} color='primary'>
                Não
              </Button>
              : <Button onClick={this.handleClose} color='primary'>
                Sair
              </Button>
            }
            { !this.props.editavel
              ? <Button onClick={handleClick} color='primary'>
                Sim
              </Button>
              : <Button
                disabled={this.state.valorCampoDialog === ''}
                onClick={this.handleClickConfirmar}
                color='primary'>
                Confirmar
              </Button>
            }
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}
export default withStyles(styles)(AlertDialogSlide);
